<template>
  <v-stepper v-model="step">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1">
        Account
      </v-stepper-step>
      <v-divider />
      <v-stepper-step :complete="step > 2" step="2">
        Payment
      </v-stepper-step>
      <v-divider />
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-form ref="account" @submit.prevent="accountSubmit">
          <v-text-field
            v-model="email"
            type="email"
            :rules="[required]"
            label="Email address"
            :error-messages="emailErrors"
            browser-autocomplete="email"
            validate-on-blur
          />
          <v-text-field
            v-model="passwordFirst"
            type="password"
            :rules="[required]"
            label="Password"
            :error-messages="passwordErrors"
            browser-autocomplete="new-password"
            validate-on-blur
          />
          <v-text-field
            v-model="passwordSecond"
            type="password"
            :rules="[required, matchesFirst]"
            label="Confirm Password"
            browser-autocomplete="new-password"
            validate-on-blur
          />
          <v-btn type="submit">
            Next
          </v-btn>
        </v-form>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-form ref="payment" @submit.prevent="payment">
          <v-btn type="button" @click="step = 1">
            Back
          </v-btn>
          <v-btn type="submit" :loading="isLoading">
            Pay
          </v-btn>
        </v-form>
      </v-stepper-content>
    </v-stepper-items>
    <vue-stripe-checkout
      ref="checkout"
      :amount="1000"
      name="Property Fire Subscription"
      :email="email"
      panel-label="Subscribe"
    />
  </v-stepper>
</template>

<script>
import { functions } from 'firebase/app';
import 'firebase/functions';
import { auth } from '@/plugins/firebase';
import { required } from '@/util';

export default {
  name: 'CreateAdminFlow',
  data: () => ({
    step: 1,
    email: null,
    passwordFirst: null,
    passwordSecond: null,
    uid: null,
    emailErrors: [],
    passwordErrors: [],
    isLoading: false,
  }),
  methods: {
    required,
    matchesFirst(val) {
      return val === this.passwordFirst || 'Passwords must match';
    },
    async accountSubmit() {
      this.emailErrors = [];
      if (!this.$refs.account.validate()) return;
      try {
        const {
          user: { uid },
        } = await auth.createUserWithEmailAndPassword(
          this.email,
          this.passwordFirst,
        );
        this.uid = uid;
        this.step = 2;
      } catch (err) {
        switch (err.code) {
          case 'auth/email-already-in-use':
            this.emailErrors = ['Email is taken'];
            break;
          case 'auth/invalid-email':
            this.emailErrors = ['Email is invalid'];
            break;
          case 'auth/weak-password':
            this.passwordErrors = ['Password is too weak'];
            break;
          default:
            throw err;
        }
      }
    },
    async payment() {
      const { token } = await this.$refs.checkout.open();
      this.isLoading = true;
      await functions().httpsCallable('createAdminAccount')({
        token: token.id,
        uid: this.uid,
        email: this.email,
      });
      this.isLoading = false;
      this.$router.push('/redirect');
    },
  },
};
</script>

<style></style>
